import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '@/stores/auth.store';
import { isPathLocked, bypassesModuleLocks } from '@/constants/module-locks';

// Bloqueo TEMPORAL de módulos no operativos (transición legacy → SIME nuevo).
// El sidebar ya oculta los módulos bloqueados; este guard cierra el acceso por
// URL directa / deep-link (ej. un no-admin escribe `/planes` o `/resso/:id`).
// Solo aplica DENTRO del AppShell: las rutas `/l/*` (Modo Líder) y `/miniapp/*`
// (Codelco) están en otras ramas de <Routes> y no pasan por acá.
// El ADMINISTRADOR (bypass) nunca se bloquea. Para desbloquear un módulo, ver
// `@/constants/module-locks`.
export function ModuleLockGuard({ children }: { children: ReactNode }) {
  const role = useAuthStore((s) => s.user?.tipoUsuarioId);
  const location = useLocation();

  if (isPathLocked(location.pathname) && !bypassesModuleLocks(role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
